import React from "react";
import WhatAppOffers from "./body/WhatAppOffers";
import Examples from "./examples/Examples";
import LoginAndRegister from "./loginAndRegister/LoginAndRegister";
import IUser from "../../types/user.type";
import Cards from "../cards/Cards";

type Props = {
  updateUserState: (user: IUser) => void;
};

const Home: React.FC<Props> = ({ updateUserState }) => {
  return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "2rem",
          padding: "2rem"
        }}
      >
        <div style={{ width: "100%", maxWidth: "420px" }}>
          <LoginAndRegister updateUserState={updateUserState} />
        </div>

        <div style={{ width: "90%" }}>
          <WhatAppOffers />
        </div>

        <div style={{ width: "90%" }}>
          <Cards />
          {/* <Examples /> */}
        </div>
      </div>
  );
};

export default Home;
